var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.id)?_c('StudioModule',{attrs:{"id":_vm.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }